import primaryComponents from "../../../primaryComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useCustomersExport from "./useCustomersExport";
import { DOB_DAYS, DOB_YEARS, MONTHS_OF_YEAR_FULL } from "../../../../helpers";

export const CustomersExport = ({
  closeWidget,
  currentStore,
  searchParams,
}) => {
  const {
    selectedStore,
    setSelectedStore,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    dobDay,
    setDobDay,
    dobMonth,
    setDobMonth,
    dobYear,
    setDobYear,
    isExporting,
    storeList,
    handleExport,
  } = useCustomersExport({
    closeWidget,
    currentStore,
    searchParams,
  });

  return (
    <div
      className="d-flex flex-column justify-content-between"
      style={{
        minHeight: "100%",
        paddingBottom: "30px",
        touchAction: "pan-y",
      }}
    >
      <div>
        <primaryComponents.Button
          classNames="btn btn--outline smallBtn"
          onClick={closeWidget}
        >
          <FontAwesomeIcon icon="angle-left" style={{ fontSize: "15px" }} />
        </primaryComponents.Button>
      </div>

      <div className="mt-3">
        <h4>Export Customer Data</h4>
        <p className="gray--text smallest-text-size mb-0">
          Download your customer records as a CSV spreadsheet.
        </p>
      </div>

      <form
        className="d-flex flex-column mt-3"
        style={{ gap: "16px", flexGrow: 1 }}
        id="exportCustomersForm"
        onSubmit={handleExport}
      >
        {/* Store Selection */}
        <div>
          <label className="mb-1 font-weight-normal">Filter by Store</label>
          <primaryComponents.SelectField
            options={[{ id: "", name: "All Stores" }, ...storeList]}
            idKey="id"
            nameKey="name"
            value={
              selectedStore
                ? storeList?.find((s) => `${s?.id}` === `${selectedStore}`)
                    ?.name || "All Stores"
                : "All Stores"
            }
            onChange={(val) => setSelectedStore(val)}
            placeholder="Select Store"
            floatError={false}
          />
        </div>

        {/* Date Range Selection */}
        <div>
          <label className="mb-1 font-weight-normal">
            Registration Date Range (Optional)
          </label>
          <div
            className="d-flex align-items-center flex-column flex-sm-row"
            style={{ gap: "10px" }}
          >
            <div className="flex-fill w-100">
              <primaryComponents.DateInput
                label="From"
                value={startDate}
                onChange={({ target: { value } }) => setStartDate(value)}
              />
            </div>
            <span className="gray--text smallest-text-size d-none d-sm-inline">
              to
            </span>
            <div className="flex-fill w-100">
              <primaryComponents.DateInput
                label="To"
                value={endDate}
                onChange={({ target: { value } }) => setEndDate(value)}
              />
            </div>
          </div>
        </div>

        {/* Date of Birth Filter */}
        <div>
          <label className="mb-1 font-weight-normal">
            Date of Birth Filter (Optional)
          </label>
          <div
            className="d-flex flex-column flex-sm-row"
            style={{ gap: "8px" }}
          >
            <div className="flex-fill w-100" style={{ minWidth: 0 }}>
              <primaryComponents.SelectField
                label="Day"
                placeholder="Select Day"
                value={dobDay ? String(dobDay).padStart(2, "0") : "Select Day"}
                options={[{ id: "", name: "Select Day" }, ...DOB_DAYS]}
                idKey="id"
                nameKey="name"
                onChange={(val) => setDobDay(val)}
                floatError={false}
              />
            </div>
            <div className="flex-fill w-100" style={{ minWidth: 0 }}>
              <primaryComponents.SelectField
                label="Month"
                placeholder="Select Month"
                value={
                  dobMonth ? MONTHS_OF_YEAR_FULL[dobMonth - 1] : "Select Month"
                }
                options={[
                  { id: "", name: "Select Month" },
                  ...MONTHS_OF_YEAR_FULL.map((name, i) => ({
                    id: i + 1,
                    name,
                  })),
                ]}
                idKey="id"
                nameKey="name"
                onChange={(val) => setDobMonth(val)}
                floatError={false}
              />
            </div>
            <div className="flex-fill w-100" style={{ minWidth: 0 }}>
              <primaryComponents.SelectField
                label="Year (optional)"
                placeholder="Select Year"
                value={dobYear ? String(dobYear) : "Select Year"}
                options={DOB_YEARS}
                idKey="id"
                nameKey="name"
                onChange={(val) => setDobYear(val)}
                floatError={false}
              />
            </div>
          </div>
        </div>
      </form>

      <primaryComponents.Button
        type="submit"
        form="exportCustomersForm"
        classNames="btn btn--primary cover mt-4"
        isDisabled={isExporting}
        isLoading={isExporting}
        loadingText="Exporting..."
      >
        <FontAwesomeIcon icon="download" className="mr-2" />
        Download CSV
      </primaryComponents.Button>
    </div>
  );
};

export default CustomersExport;
